import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/ConsumersIllustration.tsx
const ConsumersIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "consumers.svg",
		alt: t("illustration.imageAlt.consumers")
	});
};

//#endregion
export { ConsumersIllustration };